import { t } from "ttag";

import { Header } from "@/shared/ui";

export const ShopOverviewHeader = () => {
  return (
    <Header.Root>
      <Header.Content>
        <Header.Title>{t`Shop`}</Header.Title>
      </Header.Content>
    </Header.Root>
  );
};
